/**
 * Input Schema of ResponsavelGrupoEconomico
 * @author Simpli CLI generator
 */
import {Schema, FieldSet, FieldComponent, Component} from 'simpli-web-sdk'
import {ResponsavelGrupoEconomico} from '@/model/resource/ResponsavelGrupoEconomico'
import {ResponsavelCollection} from '@/model/collection/ResponsavelCollection'
import SearchResponsavel from '@/components/SearchResponsavel.vue'

export class InputResponsavelGrupoEconomicoSchema extends Schema {
  collectionResponsavel = new ResponsavelCollection().noPagination()

  formFields = ['responsavelPermitido']

  readonly name = 'InputResponsavelGrupoEconomico'

  readonly fieldSet: FieldSet<ResponsavelGrupoEconomico> = {
    responsavelMaster: (schema): FieldComponent => ({
      is: Component.InputSelect,
      bind: {
        label: this.translateFrom(schema.fieldName),
        items: this.collectionResponsavel.all(),
      },
    }),
    responsavelPermitido: (schema): FieldComponent => ({
      is: SearchResponsavel,
      bind: {
        label: this.translateFrom(schema.fieldName),
        class: 'col-span-2',
        collection: this.collectionResponsavel,
        noResultLabel: this.translateFrom('noResultLabel'),
        noOptionsLabel: this.translateFrom('noOptionsLabel'),
        required: true,
        showLabels: true,
      },
    }),
    dataCriacao: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'mask',
        maskPreset: 'datetime',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
      },
    }),
    senha: (schema): FieldComponent => ({
      is: Component.InputText,
      bind: {
        type: 'password',
        label: this.translateFrom(schema.fieldName),
        required: true,
        validation: 'required',
        autocomplete: 'nope',
      },
    }),
  }
}
